import { render, staticRenderFns } from "./ArtGuideEventsReorderControlEventsList.vue?vue&type=template&id=4477a39d&scoped=true&"
import script from "./ArtGuideEventsReorderControlEventsList.vue?vue&type=script&lang=js&"
export * from "./ArtGuideEventsReorderControlEventsList.vue?vue&type=script&lang=js&"
import style0 from "./ArtGuideEventsReorderControlEventsList.vue?vue&type=style&index=0&id=4477a39d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4477a39d",
  null
  
)

export default component.exports